import { useMemo, useReducer, useRef } from 'react';

export default function useReferenceScroller() {
  const stepsRefs = useRef<Map<string, HTMLElement>>(new Map());
  const [, rerender] = useReducer(x => x + 1, 0);

  const willSaveScreenRef = useMemo(() =>
    // memoization is a need here, not a perf improvement, in order to prevent infinite rendering
    memoize((id: string) => (el: HTMLElement | null) => {
      if (el) {
        stepsRefs.current.set(id, el);
      } else {
        stepsRefs.current.delete(id);
      }
      rerender(); // would have been preferable if the dic was a state
    }),
    []);

  const getStepElement = (id: string): HTMLElement | undefined => {
    return stepsRefs.current.get(id);
  };

  return {
    registerStep: willSaveScreenRef,
    getStepElement,
  };
// simple memoization by serializing params to json
// warning: it's a memory leak.
function memoize<F extends (...p: any[]) => any>(fn: F) {
  const cache = {};
  return ((...args) => {
    const key: string = JSON.stringify(args);
    if (key in cache)
      return cache[key];
    return cache[key] = fn(...args);
  }) as F;
}


}
